module.exports = __webpack_public_path__ + "static/1288032384.97bd2bfd.jpg";